import { render, staticRenderFns } from "./Forget.vue?vue&type=template&id=e4cd8ea2&scoped=true&"
import script from "./Forget.vue?vue&type=script&lang=ts&"
export * from "./Forget.vue?vue&type=script&lang=ts&"
import style0 from "./Forget.vue?vue&type=style&index=0&id=e4cd8ea2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4cd8ea2",
  null
  
)

export default component.exports